 const PRIORITY_ICON ={
    HIGH: "icon-sgs12",
    LOW:"icon-sgs5"
  }
 export const SVG_ICON_NAME= {
  _3PL: "3PL",
  SWAP: "SWAP",
  dailyPickup: "dailyPickup",
  ExcessiveLength: "ExcessiveLength",
  isTrailerDrop:"isTrailerDrop",
  CustomerComments: "CustomerComments",
  ShipperComments: "ShipperComments"
 }
const appConstants = {
  layout: {
    ShipmentsMap: "ShipmentsMap",
    RoutesMap: "RoutesMap",
    SettingsPage: "SettingsPage",
    QuickFilter: "QuickFilter",
    KPIPanel: "KPIPanel",
    Reports: "Reports",
    DispatchDriversMap: "DispatchDriversMap",
    CustomerMap: "CustomerMap",
    CustomerQuickFilter: "CustomerQuickFilter",
  },
  columnTypes: {
    STRING: "string",
    NUMBER: "number",
    DOUBLE: "double",
    DATE: "date",
    TIME: "time",
    BOOLEAN: "boolean",
    PERCENTAGE: "percentage",
    TEXT: "text",
    DATETIME: "datetime",
  },
  gridNames: {
    ShipmentsGrid: "ShipmentsSelection",
    IBShipmentsGrid: "IBShipmentsGrid",
    CustomerGrid: "CustomerGrid",
    ShipperGrid : "ShipperGrid",
    RoutesGrid: "RoutesGrid",
    StopsGrid: "StopsGrid",
    TrailerInventory: "TrailerInventory",
    AnchorPoint: "AnchorPoint",
    Parameters: "Parameters",
    StemMiles: "StemMiles",
    ZoneMiles: "ZoneMiles",
    TerminalAccess: "TerminalAccess",
    FeederTerminal: "FeederTerminal",
    ScenarioExplorer: "ScenarioExplorer",
    AnchorPointGrid: "AnchorPointGrid",
    UNRTDShipments: "UNRTDShipments",
    KPIGoals: "KPIGoals",
    IBPlanningSummary: "IBPlanningSummary",
    DriverPreferences: "DriverPreferences",
    RouteEquipmentPreference: "RouteEquipmentPreference",
    ProHistory: "ProHistory",
    DockCompliance: "DockCompliance",
    NextStopCompliance: "NextStopCompliance",
    DriverDispatchGrid: "DriverDispatchGrid",
    DriverGrid: "DriverGrid",
    TrailersGrid: "TrailersGrid",
    DispatchedDriverGrid: "DispatchedDriverGrid",
    DispatchQuickFilter: "DispatchQuickFilter",
    PickupsGrid: "PickupsGrid",
    DriverInfoGrid: "DriverInfoGrid",
    ScheduleGrid: "ScheduleGrid",
    DispatchPickupInfoGrid: "DispatchPickupInfoGrid",
    DispatchGroupMsg: "DispatchGroupMsg",
    DuplicateCustomerGrid: "DuplicateCustomerGrid",
    MergedCustomerGrid: "MergedCustomerGrid",
    ReturnsGrid: "ReturnsGrid",
    ShipmentsEventStream: "ShipmentsEventStream",
    AddNewShipmentsGrid : "AddNewShipmentsGrid",
    DropYardGrid: "DropYardGrid"
  },
  mapIds: {
    CUSTOMER_MAP: "customerMap",
    EDIT_CUSTOMER_MAP: "editCustomerMap",
    DROP_YARD_MAP: "DropYardMap",
  },
  KPI_NAME: {
    DispatchKPI: "DispatchKPI",
  },
  mapName: {
    DispatchMap: "DispatchMap",
  },
  Map: "Google", // defined which MAP should be used as Map Component
  columnWidth: {
    TERMINAL: 120,
    PROID: 125,
    TRAP: 130,
    CUBE: 130,
    ROUTES: 95,
    ROUTE_MODE: 65,
    DRIVER_ROUTE: 125,
    MAX_TRAILER: 120,
    IBETA: 145,
    LG: 73,
    REGION_ID: 150,
    PIECES: 120,
    HU: 100,
    GEOCODING: 110,
    WEIGHT: 120,
    SERVICE_LEVEL: 120,
    TOTAL_PIECES: 120,
    AREA: 83,
    DUE_DATE: 115,
    DELIVERY_WINDOW: 200,
    EARLY_LATE_CTA: 150,
    APT_WINDOW: 230,
    PICKUP_WINDOW: 180,
    CUSTOMER: 190,
    CUSTOMER_CODE: 150,
    RETURN_CODE: 150,
    CUSTOMER_ADDRESS: 180,
    EQUIPMENT_PREFERENCE: 115,
    TRAILER_ID: 120,
    MANIFEST_ID: 128,
    LOCK_STATUS: 90,
    TOTAL_STOPS: 104,
    PROS: 120,
    TRAILER_TYPE: 120,
    LIFT_GATE: 120,
    TOTAL_MILES: 103,
    TOTAL_TIME: 100,
    EMPTY_TIME: 122,
    DRIVER_NAME: 100,
    TRIPS: 130,
    TOTAL_COST: 120,
    LOADCLOSE_TIME: 147,
    START_TIME: 113,
    TRACTOR_ID: 140,
    ANCHORPOINT_NAME: 128,
    COMMENTS: 117,
    ISSTATIC_ROUTE: 170,
    STOP_SEQUENCE: 110,
    CONSIGNEE_ID: 170,
    CONSIGNEE_NAME: 190,
    ZIP_CODE: 85,
    APPOINTMENT: 120,
    LATITUDE: 160,
    LONGITUDE: 160,
    ROUTE_STOP_ID: 170,
    STOP_TYPE: 150,
    STOP_TIME: 150,
    TOTAL_BILLS: 95,
    STOP_STATUS: 120,
    SPECIAL_INSTRUCTION: 140,
    ETA: 80,
    ETD: 80,
    ROUTES_NAME: 110,
    ROUTEID: 150,
    INPLAN: 95,
    CITY: 140,
    SHIPPER_STATE: 132,
    STATE: 87,
    CUBIC_FEET: 115,
    WAVE: 87,
    PREP_TIME: 112,
    SHIPMENT_STATUS: 147,
    RETURN_REASON: 139,
    LOADED_BILLS: 120,
    PRO_COUNT: 110,
    APT: 76,
    PRIORITY: 98,
    SPL_NEED: 130,
    PICKUP_TYPE: 110,
    BILLS: 80,
    LDG_ZONE: 108,
    ILINE: 90,
    ORDER_NUMBER: 125,
    PARAMETER: 500,
    PARAM_DEFAULT: 200,
    PARAM_CUSTOM: 200,
    SPEED_MILES_RANGE: 200,
    SPEED_MILES_VALUE: 200,
    PACKAGE_TYPE: 130,
    PALLET_COUNT: 125,
    PSE: 80,
    CALCULATED_PSE: 140,
    VIOLATION_DOT: 20,
    AP_STATUS: 90,
    AP_NAME: 180,
    AP_EMPTYTIME: 90,
    AP_STARTTIME: 90,
    AP_ROUTE: 200,
    SCENARIO_ID: 100,
    PRO_ID: 200,
    APT_DUE_DATE: 132,
    PKG_TYPE: 100,
    ACC_HRS: 95,
    ACC_HRS_132: 132,
    WEEKLY_ACC_HRS: 140,
    DISPATCH_DRIVER_NAME: 180,
    STATUS: 120,
    UNOCC_TRAILER_SPACE: 180,
    TOTAL_HU: 110,
    DELIVERIES_GROUP: 120,
    PICKUPS_GROUP: 120,
    ASSIGN_ACTION: 130,
    ROUTE_NAME: 120,
    PICKUP_DATE: 120,
    DISPATCH_IBOB_TERMINAL: 130,
    FROZEN_PALLETS: 130,
    NON_FROZEN_PALLETS: 160,
    TEMP_TYPE: 120,

    FEEDER_TERMINAL: 400,
    REGION: 80,
    DIVISION: 80,
    ACTION: 130,

    TERMINAL_USER: 190,
    TERMINAL_FIRSTNAME: 115,
    TERMINAL_LASTNAME: 115,
    TERMINAL_EMAIL: 250,
    TERMINAL_JOBTITLE: 150,
    TERMINAL_DEFAULTTERMINAL: 150,
    TERMINAL_TERMINALLIST: 200,
    TERMINAL_COMMANDS: 130,

    KPI_NAME: 150,
    KPI_VALUE: 150,

    NOTIFICATION_TYPE: 120,
    NOTIFICATION_MESSAGE: 200,
    NOTIFICATION_LINK: 100,
    NOTIFICATION_ISCLOSABLE: 100,
    NOTIFICATION_ISACTIVE: 100,
    NOTIFICATION_COMMAND: 120,

    //Dock Compliance Report
    DCR_COMPLIANCE: 100,
    DCR_ROUTETYPE: 80,
    DCR_COMPLIANCE_PROUTE: 130,
    DCR_COMPLIANCE_UNPL: 140,
    DCR_COMPLIANCE_DROUTE: 150,
    DCR_COMPLIANCE_MATCHED: 125,
    DCR_COMPLIANCE_MANIFEST: 120,

    REPORTS_TERMINALCODE: 100,
    REPORTS_TERMINALNAME: 140,
    REPORTS_REGION: 90,
    REPORTS_DIVISION: 120,
    REPORTS_PROCOUNT: 90,
    REPORTS_PUBLISHCOUNT: 90,
    REPORTS_ROUTECOUNT: 90,
    REPORTS_FIRSTPUSH: 120,
    REPORTS_FIRSTPUBLISH: 125,
    REPORTS_LASTPUBLISH: 130,
    REPORTS_PRO_CHANGED_BY: 250,
    REPORTS_USER: 180,

    DUPLICATE_CUSTOMERS_ROUTE: 100,
    DUPLICATE_CUSTOMERS_CUSTOMER: 120,
    DUPLICATE_CUSTOMERS_ADDRESS: 200,
    DUPLICATE_CUSTOMERS_CITY: 100,
    DUPLICATE_CUSTOMERS_DELIVERY_WINDOW: 140,

    DP_DRIVERID: 350,
    DP_DRIVERNAME: 150,
    DP_STARTTIME: 150,
    DP_ZONE: 100,
    ROUTE_EQMT_MAP_ROUTE: 150,
    ROUTE_EQMT_MAP_TRAILER: 150,

    HOLIDAY_NAME:120,

    DISPATCH_TRAILER: 110,
    DISPATCH_MANIFEST: 120,
    DISPATCH_TRAILER_TYPE: 120,
    DISPATCH_TRAILER_STATUS: 140,
    DISPATCH_TRAILER_CLASS: 80,
    DISPATCH_TRACTOR: 120,
    DISPATCH_DRIVER_STATUS: 260,
    DISPATCH_ROUTE_NAME: 120,
    DISPATCH_ACTION: 140,
    DISPATCH_ZONE: 80,
    DISPATCH: 120,
    PICKUP_NUMBER: 140,
    MERGED_PICKUP_ICON: 25,
    PRO_NUMBER: 140,
    DRIVER_NUMBER: 140,
    DRIVER_TYPE: 110,
    DRIVER_ZONE: 150,
    DRIVER_DRIVER_NAME: 200,
    DRIVER_CALL_TIME: 150,
    DRIVER_SCHEDULED_TIME: 150,
    DRIVER_SCHEDULED_DATE: 150,
    DRIVER_ADDRESS: 250,
    DRIVER_STATUS: 200,
    PHONE_NUMBER: 200,

    DRIVER_INFO: 140,
    DRIVER_INFO_SMALL: 80,
    CUSTOMER_NAME: 250,
    STOPS: 100,
    ARRIVAL_TIME: 130,
    DEPARTURE_TIME: 156,
    EXPECTED_DEPARTURE_TIME: 130,
    OCC_PSE: 130,

    OPTIMIZATION_PICKUP_NAME: 220,
    OPTIMIZATION_DELIVERY_WINDOW: 100,
    OPTIMIZATION_PSE: 80,

    DISPATCH_GROUP_MSG_TIME: 115,
    DISPATCH_GROUP_MSG_FROM: 130,
    DISPATCH_GROUP_MSG_TO: 140,
    DISPATCH_GROUP_MSG_MESSAGE: 400,

    NEXT_STOP_COMPLIANCE_ROUTE: 160,
    NEXT_STOP_COMPLIANCE_DRIVER_NAME: 190,
    NEXT_STOP_COMPLIANCE_MANIFEST: 130,
    NEXT_STOP_COMPLIANCE_TOTAL_TIME: 120,

    DATE_TIME: 130,
    CLOSE_TIME: 115,
    ETA_TIME: 90,
    ELAPSE_TIME: 130,
    LAST_ACTIVE_TIME: 130,

    EQUIPMENT: 110,
    CATEGORY: 100,
    SUB_CATEGORY: 100,
    DEFECT: 200,
    SEVERITY: 60,
    DEFECT_DATE: 80,

    //we may need to use different width for same field in different grids. we can do this by using below values .
    W_50: 50,
    W_62: 62,
    W_65: 65,
    W_70: 70,
    W_80: 80,
    W_85: 85,
    W_90: 90,
    W_95: 95,
    W_100: 100,
    W_110: 110,
    W_115: 115,
    W_120: 120,
    W_125: 125,
    W_135: 135,
    W_140: 140,
    W_150: 150,
    W_160: 160,
    W_170: 170,
    W_180: 180,
    W_190: 190,
    W_200: 200,
    W_250: 250,
  },
  routeDisplayColorOptions: [
    "#17d097",
    "#ff2989",
    "#af2ce5",
    "#a7a7a7",
    "#4da75e",
    "#ff8b24",
    "#45a8ee",
    "#88d41b",
    "#ee5145",
    "#c68870",
    "#00742a",
    "#950074",
    "#b588ff",
    "#5eadb0",
    "#921500",
    "#00636c",
    "#6e7800",
    "#6434ff",
    "#ff8fc1",
  ],
  Event: {
    ROUTE_SELECTED: "routeSelected",
    STOP_SELECTED_MAP: "stopSelectedOnMap",
    STOP_SELECTED_GRID: "stopSelectedOnGrid",
    SHIPMENT_SELECTED_GRID: "ShipmentSelectedOnGrid",
    PICKUP_SELECTED_GRID: "pickupSelectedOnGrid",
    PICKUP_SELECTED_MAP: "selectedPickupChangedOnMap",
    SELECT_PICKUP_ROUTES: "selectPickupRoutes",
    DISPATCH_ROUTE_SELECTED: "dispatchRouteSelected",
    SHIPMENT_SELECTED_MAP: "ShipmentSelectedOnMap",
    STOP_UPDATE_SEQUENCE: "updateStopSequence",
    SHIPMENT_FILTERED_GRID: "ShipmentFilteredonGrid",
    CLOSE_LASSO_PANEL: "CloseLassoPanel",
    RESTOREIBSTORE: "RestoreIBStore",
  },
  LockStates: [
    { value: 0, text: "Unlock", icon: "icon-lock-open" },
    { value: 1, text: "Partial-lock", icon: "icon-lock-open-alt" },
    { value: 2, text: "Lock", icon: "icon-lock" },
  ],
  geoCode: [
    {
      value: true,
      text: "GeoCoded",
      icon: "icon-geoCoded",
    },
    {
      value: false,
      text: "Not GeoCoded",
      icon: "icon-notGeoCoded",
    },
  ],
  SpecialNeeds: [
    { value: "APT", text: "APT", icon: "icon-apt", tooltip: "APT shipment" },
    { value: "L", text: "LG", icon: "icon-liftgate", tooltip: "LG Required" },
    { value: "Pup", text: "PUP", icon: "icon-pup", tooltip: "PUP Required" },
    {
      value: "PupLG",
      text: "PUP LG",
      icon: "icon-pup",
      tooltip: "PUP LG Required",
    },
    {
      value: "StraightTruck",
      text: "Bobtail",
      icon: "icon-truck-1",
      tooltip: "Bobtail/Small Truck Required",
    },
    {
      value: "StraightTruckLG",
      text: "Bobtail LG",
      icon: "icon-truck-1",
      tooltip: "Bobtail/Small Truck LG Required",
    },
    { value: "PZ", text: "Poison", icon: "icon-issue", tooltip: "Poison" },
    { value: "HZ", text: "Hazard", icon: "icon-hazmat", tooltip: "Hazmat" },
    { value: "FD", text: "Food", icon: "icon-food", tooltip: "Food" },
    { value: "FZ", text: "Frozen", icon: "icon-freeze", tooltip: "Freezable" },
    { value: "LA", text: "Limited", icon: "icon-limited", tooltip: "Limited" },
    {
      value: "RES",
      text: "Residential",
      icon: "icon-residential",
      tooltip: "Residential",
    },
    {
      value: "specialInstruction",
      text: "Special Instructions",
      icon: "icon-special-instructions",
      tooltip: "Special Instructions",
    },
    {
      value: SVG_ICON_NAME.ExcessiveLength,
      text: "Excessive Length",
      svgIcon: SVG_ICON_NAME.ExcessiveLength,
      tooltip: "Excessive Length",
    },
    {
      value: SVG_ICON_NAME.CustomerComments,
      text: "Customer Comments",
      svgIcon: SVG_ICON_NAME.CustomerComments,
      tooltip: "Customer Comments",
    },
    {
      value: SVG_ICON_NAME.ShipperComments,
      text: "Shipper Comments",
      svgIcon: SVG_ICON_NAME.ShipperComments,
      tooltip: "Shipper Comments",
    },
    { value: "", text: "(BLANKS)" },
  ],
  STOP_GRID_SPECIAL_NEEDS:[{
    value: SVG_ICON_NAME.isTrailerDrop,
    text: "Trailer Drop",
    svgIcon: SVG_ICON_NAME.isTrailerDrop,
    tooltip: "Trailer Drop",
  }],
  Colors: {
    markerActiveColor: "#80F4DA",
    transparent: "transparent",
    notificationIconColor: "#CCCCCC",
    disabledColor: "#909093",
  },
  UNRTD_ROUTENAME: "UNRTD",
  BLANK: "(BLANKS)",
  EMPTY_STRING: "",
  DATETYPES: {
    DATE: {
      type: "Date",
      format: "MM/dd",
      placeholder: "MM/DD",
      inputMask: [/\d/, /\d/, "/", /\d/, /\d/],
      updateFormat: "yyyy-MM-dd'T'00:00:00.000Z",
    },
    DATEYEAR: {
      type: "Date",
      format: "yy/MM/dd",
      placeholder: "YY/MM/DD",
      inputMask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/],
      updateFormat: "yyyy-MM-dd'T'00:00:00.000Z",
    },
    YEARDATETIME:{
      type: "YearDateTime",
      format: "yyyy-MM-dd HH:mm",
      displayFormat:"MM/dd/yyyy HH:mm", // to be used when data format is not same as format viewed by user
      placeholder: "MM/DD/YYYY HH:MM",
      inputMask: [
        /\d/,
        /\d/,
        "/",
        /\d/,
        /\d/,
        "/",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        ":",
        /\d/,
        /\d/,
      ],
      updateFormat: "yyyy-MM-dd'T'HH:mm:00.000Z",
      intervalSeperator: " - ",
    },
    TIME: {
      type: "Time",
      format: "HH:mm",
      placeholder: "HH:MM",
      inputMask: [/\d/, /\d/, ":", /\d/, /\d/],
      intervalSeperator: "-",
      updateFormat: "yyyy-MM-dd'T'HH:mm:00.000Z",
    },
    DATETIME: {
      type: "DateTime",
      format: "MM/dd HH:mm",
      placeholder: "MM/DD HH:MM",
      inputMask: [
        /\d/,
        /\d/,
        "/",
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        ":",
        /\d/,
        /\d/,
      ],
      updateFormat: "yyyy-MM-dd'T'HH:mm:00.000Z",
      intervalSeperator: "-",
    },
    MONTHDATEYEAR: {
      type: "Date",
      format: "MM/dd/yy",
      placeholder: "MM/DD/YY",
      inputMask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/],
      updateFormat: "yyyy-MM-dd'T'00:00:00.000Z",
    },
    DATETIMEWITHOUTTIMEZONE: {
      format: "yyyy-MM-dd'T'00:00:00.000",
    },
  },
  ERROR_MESSAGE: {
    GRID_DATA_FETCH_FAILED: "Something went wrong",
  },
  routeLockStates: {
    LOCK: {
      value: 2,
      text: "Lock",
      icon: "icon-locked",
      toolTipInfo: "Cannot add/remove shipments to this route",
    },
    PARTIAL_LOCK: {
      value: 1,
      text: "Partial-lock",
      icon: "icon-partial-locked",
      toolTipInfo: "Can only add shipments to the route",
    },
    UNLOCK: {
      value: 0,
      text: "Unlock",
      icon: "icon-unclock",
      toolTipInfo: "Can add/remove shipments to the route",
    },
  },
  shipmentPlanStates: [
    { value: true, text: "In Plan" },
    { value: false, text: "Out of Plan" },
  ],
  STOP_MOVES: {
    RESEQUENCE: "resequence",
    CHANGE_ROUTE: "changeRoute",
    SINGLE_STOP_ROUTECHANGE: "singleStopRouteChange",
    SWAP_STOP_SEQ: "swapStopSequence",
    MARK_NEXT_STOP: "markNextStop",
  },
  STOP_STATUS: {
    DELAYED: "Delayed",
    ONTIME: "On-Time",
    EARLY_ARRIVAL: "Early Arrival",
  },
  VIOLATION_MESSAGES: {
    LATE_PROS: "Pros arriving too late for route start time",
  },
  FILTER_TYPES: {
    STRING: "string",
    NUMBER: "number",
  },
  DYNAMIC_ROUTING_PROGRESS_MESSAGES: [
    'Without leaving the Route Planning screen, you can move shipments between routes in either the Shipments grid or the Stops grid by using the "Edit" button.',
    "Red dots in the Routes and Stops grids (if present) indicate violations. Hold the mouse over a red dot to see the violation(s).",
    "Click the Sequence Optimizer button to put all the stops within the selected (highlighted) routes into their best order. This button will NOT move shipments between routes.",
    "To revert a bad stop move, click the Undo button in the Stop Move feedback panel. This panel slides into the top right corner, but only when the stop move has caused a significant change.",
    "Keep up to date on the latest features, tutorials & videos in the RouteMAX Help Center. Click on the Help button (just to the right of the Optimize button) and select “What’s New.”",
  ],
  APPOINTMENT_ROUTES: ["APP_1", "APM_1", "APT_1", "APW_1", "APH_1", "APF_1"],
  ROUTE_TYPES: {
    CITY: "City",
    TRAP: "Trap",
  },

  ROUTE_TYPES_LIST: [
    { value: "City", text: "City" },
    { value: "Trap", text: "Trap" },
  ],

  NAV_URLS: {
    HOME: "/",
    LOGIN: "/login",
    IBPLANNING_HOME: "/ibplanning",
    IBPLANNING_SHIPMENTS: "/ibplanning/shipments",
    IBPLANNING_ROUTES: "/ibplanning/routes",
    IBPLANNING_CUSTOMERS: "/ibplanning/customers",
    SHIPMENT_SELECTION: "/shipmentselection",
    DISPATCH_HOME: "/dispatch",
    DISPATCH_ASSET_MANAGEMENT: "/dispatch/assetmanagment",
    DISPATCH_ROUTEEXECUTION: "/dispatch/routes",
    REPORT_HOME: "/reports",
    REPORT_IBPSUMMARY: "/reports/ibplanningsummary",
    REPORT_PUBLISH_STATUS: "/reports/publishstatus",
    REPORT_DOCK_COMPLIANCE: "/reports/dockcompliance",
    REPORT_DRIVER_PERFORMANCE: "/reports/driverperformance",
    REPORT_DRIVER_PERFORMANCE_LIVE: "/dispatch/driverperformancelive",
    REPORT_PRO_HISTORY: "/reports/prohistory",
    REPORT_KPI_SUMMARY: "/reports/kpisummary",
    REPORT_DUPLICATE_CUSTOMERS: "/reports/duplicatecustomers",
    REPORT_MERGED_CUSTOMERS: "/reports/mergedcustomers",
    REPORT_SHIPMENTS_EVENT_STREAM: "/reports/shipmentseventstream",
    REPORT_USAGE_REPORT: "/reports/usagereport",
    NEXT_STOP_COMPLIANCE: "/reports/nextstopcompliance",
    SETTINGS: "/settings",
    PAGE_NOT_FOUND: "/pageNotFound",
    SERVER_ERROR: "/serverError",
    ACCESS_DENIED: "/accessdenied",
    PATH_MATCHERS: {
      RESET_PASSWORD: "/resetPassword/:moduleName",
      IBPLANNING: "/ibplanning/:moduleName(shipments|routes|customers)",
      DISPATCH:
        "/dispatch/:moduleName(routes|assetmanagment|driverperformancelive)",
      REPORTS:
        "/reports/:moduleName(ibplanningsummary|publishstatus|dockcompliance|prohistory|kpisummary|nextstopcompliance|driverperformance|duplicatecustomers|mergedcustomers|shipmentseventstream|usagereport)",
    },
  },
  ACTION: {
    FirstPush_Routes: "Initial Route from AS400",
    IncremantalPush_Routes: "Incremental Data Push ",
    UpdateShipmentRouteAssignment: "Shipment Route Changed",
    ConvertRoute: "Route Type Changed",
    UpdateRoutes: "Route Properties Updated",
    CreateRoute: "Route Created through internal operation in RouteMAX",
    UpdateRouteStops: "Stop Route Changed from Data Grid",
    UpdateRouteStopsFromMap: "Stop Route Changed from Map",
    UpdateRouteAnchorPoint: "Anchor Point Updated for Route",
    UpdateAnchorPoint: "Anchor Point Updated for Route",
    UpdateFirstStop: "First Stop Updated",
    "Copy Scenario": "Copy scenario from RouteMAX UI",
    UpdateLastStop: "Last Stop Updated",
    RunTSP: "Ran Sequence Optimization",
    UpdateShipmentsProperty: "Shipment Metadata Update",
    MergeRoutes: "Merge Routes",
    UndoVersion: "Undo Stop move",
    "Resolve version conflict": "Multiple actions happened on the PRO",
    UpdateStopSequence: "Stop Sequence Changed",
    updateCustomerLocation: "Customer Location Updated",
    IncremantalPush_Shipment: "Shipment Metadata Update",
  },
  DCR_KPI_Mapping: {
    changedBills: "Changed Bills",
    changedPercentage: "Changed %",
    compliancePercentage: "Compliance %",
    fmrtChangesSinceMorning: "FMRT Changes",
    routeChangesSinceMorning: "Route Changes",
    totalBills: "Total Bills",
    totalRmaxBills: "Total Planned Bills",
    unplannedBills: "Unplanned Bills",
    unplannedRoutes: "Unplanned Routes",
    unpublishedBills: "Unpublished Bills",
    unrtdBills: "UNRTD Bills",
    waveChangesSinceMorning: "Wave Changes",
  },
  DCR_DRILLDOWN_COMPLIANCE: 70,
  DELIVERY_CODE: {
    DC: "DC",
    DE: "DE",
    RTN: "RTN",
    TA: "TA",
    IOK: "IOK",
    SND: "SND",
  },
  SPECIAL_RETURNS: ["RF", "RD", "CNM", "DAC", "DAR"],
  SpecialNeedsStrings: {
    APT: "APT",
    FD: "FD",
    PZ: "PZ",
    HZ: "HZ",
    FZ: "FZ",
    RES: "RES",
    LA: "LA",
    L: "L",
    SI: "specialInstruction",
    CC: SVG_ICON_NAME.CustomerComments,
    SC: SVG_ICON_NAME.ShipperComments,
    ExcessiveLength: SVG_ICON_NAME.ExcessiveLength,
    TrailerDrop: SVG_ICON_NAME.isTrailerDrop,
  },
  DISPATCH_DRIVER_MAP: {
    pendingDelivery: "Pending Delivery",
    pendingPickup: "Pending Pickup",
    completedPickup: "Completed Pickup",
    unassigned: "Unassigned",
    assigned: "Assigned",
    completedDelivery: "Completed Delivery",
  },
  GRID_STATUS: {
    LOADING: "loading",
    SUCCESS: "success",
    ERROR: "error",
  },
  STOP_TYPE: {
    Delivery: "Delivery",
    Pickup: "Pickup",
  },
  PICKUP_STATUS: {
    COMPLETED: "Completed",
    WAITING: "Waiting",
    NO_FREIGHT: "No Freight",
    PENDING : "Pending"
  },
  EXCESSIVE_SHIPMENT_OPTIONS: [
    { statusCode: "C", status: "Can't See" },
    { statusCode: "Y", status: "Yes" },
    { statusCode: "N", status: "No" },
  ],
  EXCESSIVE_SHIPMENT: {
    CAN_NOT_SEE: "C",
    YES: "Y",
    NO: "N",
  },
  PICKUP_ACCESSORIAL_CODE: "P",
  DELIVERY_STOP_PRO_PENDING_STATUS: "PENDING",
  DELIVERY_ACCESSORIAL_CODE: "D",
  MESSAGE_TYPE: {
    Dispatcher: "DSP",
    Driver: "DRV",
  },
  DELIVERY_STATUS: {
    RETURN: "Return",
    DELIVERY_EXCEPTION: "Delivery Exception",
    COMPLETED: "Completed",
    PENDING: "Pending",
  },
  PICKUP_EVENTS: {
    ASSIGN_PICKUP: "AssignPickup",
    UNASSIGN_PICKUP: "UnassignPickup",
  },
  DELAY_STOP_TYPES: {
    LUNCH_BREAK: "Lunch",
    FUEL_BREAK: "Fuel",
  },
  REFRESH_DRIVER_DURATION: 60000, //(in milliseconds for 1 min)
  MIN_TRAILER_LENGTH: 8,
  MIN_LAST_REFRESH_THRESHOLD_TIME: 10, //(in min)
  DISPATCH_EVENTS: {
    UPDATE_DISPATCH_DRIVER_ROUTES: "UpdateDriverRoute",
  },
  DISPATCH_TYPE: {
    TRAILER: "trailer",
    BOBTAIL: "bobtail",
  },
  MAP_STYLE_NAME: {
    Dark: "Dark",
    Light: "Light",
    Satellite: "Satellite",
  },
  MODULES: ["Planning", "Dispatch"],
  ONE_MINUTE_TIME_OUT: 60000, //(in milliseconds for 1 min),
  features: {
    isWeightBasedRouting: "IsWeightBasedRoutingEnabled",
    IsStopTimeEditable: "IsStopTimeEditable",
    EnableDispatchDriver: "EnableDispatchDriver",
    EnableAddPro: "EnableAddPro",
    EnableChangePickupTerminal: "EnableChangePickupTerminal",
    EnableRemovePro: "EnableRemovePro",
    EnablePickupEdit: "EnablePickupEdit",
    EnableMergePickup: "EnableMergePickup",
    EnableDispatchRouteResequence: "EnableDispatchRouteResequence",
    EnableNextStopComplianceReport: "EnableNextStopComplianceReport",
    EnableDropHookMove: "EnableDropHookMove",
    EnableCheckDigit: "EnableCheckDigit",
    EnableSpeedProfiler: "EnableSpeedProfiler",
    EnableRouteEquipmentPreference: "EnableRouteEquipmentPreference",
    DisableReturnToTerminalOption: "DisableReturnToTerminalOption",
    AllowAddAnchorPoint: "AllowAddAnchorPoint",
    EnableDoorForRouteMapping : "EnableDoorForRouteMapping",
    EnableDriverPerformanceHistoricReport: "EnableDriverPerformanceHistoricReport",
  },
  gridColumnFeatureFlag: {
    DispatchedDriverGrid: {
      EnableDriverZone: "showZones",
      EnableWeeklyAccruedHours: "showWeeklyAccruedHours",
    },
  },
  ACCESSORIAL: {
    LIMITED_ACCESS: "LIMIT",
  },
  PICKUP_TYPES: [
    {
      value: SVG_ICON_NAME._3PL,
      text: SVG_ICON_NAME._3PL,
      svgIcon: SVG_ICON_NAME._3PL,
      tooltip: SVG_ICON_NAME._3PL,
    },
    {
      value: SVG_ICON_NAME.SWAP,
      text: SVG_ICON_NAME.SWAP,
      svgIcon: SVG_ICON_NAME.SWAP,
      tooltip: SVG_ICON_NAME.SWAP,
    },
    {
      value: SVG_ICON_NAME.dailyPickup,
      text: "Daily Pickup",
      svgIcon: SVG_ICON_NAME.dailyPickup,
      tooltip: "Daily Pickup",
      iconStyles: {
        color: "#E5A70D",
        size: 14,
      },
    },
  ],
  PRIORITY_ICON,
  PRIORITY_SHIPMENTS_ICONS: {
    WING: PRIORITY_ICON.HIGH,
    PTY: PRIORITY_ICON.HIGH.LOW,
    SGS12: PRIORITY_ICON.HIGH, // SAIA GAURANTEED SHIPMENT BEFORE 12PM
    SGS5: PRIORITY_ICON.HIGH.LOW, // SAIA GAURANTEED SHIPMENT BEFORE 5PM
    XA: PRIORITY_ICON.HIGH.LOW,
    SOLUTION: PRIORITY_ICON.HIGH.LOW,
    NG: PRIORITY_ICON.HIGH, // known priority
    TG: PRIORITY_ICON.HIGH.LOW,
    DG: PRIORITY_ICON.HIGH.LOW, // Day priority
  },
  DEFECTS_SEVERITY_CODES: {
    H: "High",
    L: "Low",
  },
  LOCALES: "en-US", //represents the code for human language that we want to format the number in
  APP_DATE_FORMAT: "yyyy-MM-dd",
  DAILY_ALLOWED_HOS: 8,
  MAP_ZOOM_LEVEL: 9,
  MAX_FEASIBLE_DRIVERS: 5,
  SNACKBAR_AUTO_HIDE_DURATION : 30000,
  ROUTE_STOP_TYPES : {
    DL : 'DL',
    PU : 'PU'
  },
  CUSTOMER_MANAGEMENT_QUICKFILTER_NAMES : {
    CUSTOMER_GRID : "CustomerManagementFilter",
    SHIPPER_GRID : "CustomerManagementShipperFilter"
  },
  CUSTOMER_TYPE: {
    PICKUP: "pickup",
    DELIVERY: "delivery"
  },
  APPOINTMENT_WINDOW_MINUTES: 0,
};

export default appConstants;
